import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Image } from '@bottomless/common/components';
import './Footer.scss';

export const Footer = () => (
  <footer className="footer section bg-black text-white">
    <Container>
      <Row>
        <Col xs="12" lg="5" className="mb-4">
          <a href="/" className="mb-4 d-block">
            <Image
              src="https://bottomless.imgix.net/landing/Bottomless-logo-white.png"
              useSrcset
              loading="lazy"
              height="20"
              alt="Bottomless"
            />
          </a>
          <div className="mb-4 pr-0 pr-lg-5">
            Making subscriptions easier with AI-powered subscription management and deliveries based on usage.
          </div>
          <div className="d-flex align-items-center mb-5 mb-lg-0">
            <a href="https://www.linkedin.com/company/bottomless/" className="d-flex align-items-center p-1">
              <Image
                src="https://bottomless.imgix.net/landing/linkedin.svg"
                width="18"
                height="18"
                alt="Linkedin Logo"
                className="mr-2 social-icon"
              />
            </a>
            <a href="https://www.instagram.com/bottomless/?hl=en" className="d-flex align-items-center p-1">
              <Image
                src="https://bottomless.imgix.net/landing/instagram.svg"
                width="18"
                height="18"
                alt="Instagram Logo"
                className="mr-2 social-icon"
              />
            </a>
            <a href="https://www.facebook.com/bottomless/" className="d-flex align-items-center p-1">
              <Image
                src="https://bottomless.imgix.net/landing/facebook.svg"
                width="18"
                height="18"
                alt="Facebook Logo"
                className="mr-2 social-icon"
              />
            </a>
            <a href="https://twitter.com/bottomless" className="d-flex align-items-center p-1">
              <Image
                src="https://bottomless.imgix.net/landing/x.svg"
                width="18"
                height="18"
                alt="X Logo"
                className="mr-2 social-icon"
              />
            </a>
          </div>
        </Col>
        <Col xs="12" lg="7">
          <Row>
            <Col xs="12" md="4" className="footer-links mb-4">
              <div className="footer-heading mb-3">Products</div>
              <div>
                <a href="/">Coffee</a>
              </div>
              <div>
                <a href="/pets">Pet Food</a>
              </div>
              <div>
                <a href="/bring-your-own-product">BYO</a>
              </div>
              <div>
                <a href="/gifts">Gifts</a>
              </div>
            </Col>
            <Col xs="12" md="4" className="footer-links mb-4">
              <div className="footer-heading mb-3">Company</div>
              <div>
                <a href="/partners">Partner With Us</a>
              </div>
              <div>
                <a href="/blog">Blog</a>
              </div>
              <div>
                <a href="mailto:liana@bottomless.com">Careers</a>
              </div>
              <div>
                <a href="/privacy.html">Privacy Policy</a>
              </div>
              <div>
                <a href="/terms-of-service.html">Terms of Use</a>
              </div>
            </Col>
            <Col xs="12" md="4" className="footer-links mb-4">
              <div className="footer-heading mb-3">Contact</div>
              <a href="mailto:hello@bottomless.com" className="d-flex align-items-center">
                <strong>hello@bottomless.com</strong>
              </a>
              <div className="text-white d-flex align-items-center contact-line">Seattle, WA</div>
              <div className="text-white d-flex align-items-center contact-line">8am-10pm PST, 7 days</div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="mt-4 mb-4">
        <a href="#main-content" className="text-underline d-flex align-items-center">
          Back to top
          <Image
            src="https://bottomless.imgix.net/landing-generic-v2/icon-arrow-up-white.png"
            useSrcset
            loading="lazy"
            width="20"
            height="20"
            alt="Arrow up"
            className="ml-2"
          />
        </a>
      </div>
      <hr className="bg-white mb-4 mt-2" />
      <div className="text-center">
        <div className="">© 2025 Bottomless. All rights reserved.</div>
      </div>
    </Container>
  </footer>
);
